//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Dialog } from "vant";
export default {
  name: "index",
  data: function data() {
    return {
      active: 0,
      img: require("@/assets/images/hospital/bg1.jpg")
    };
  },
  methods: {
    detail: function detail() {
      Dialog.alert({
        title: '一般检查',
        message: '检查项目包括：身高、体重、体重指数、收缩压'
      }).then(function () {// on close
      });
    },
    toNext0: function toNext0() {
      this.$router.push({
        name: 'checkInfo'
      });
    },
    toNext1: function toNext1() {
      this.active = 0;
    },
    toNext2: function toNext2() {
      this.active = 1;
    },
    toOrders: function toOrders() {
      this.$router.push({
        name: 'orders'
      });
    },
    toHome: function toHome() {
      this.$router.push({
        name: 'home'
      });
    }
  }
};